import { register } from "async-ops";
import { callMvcApi } from "../../../call-web-api";
export const FETCH_SERVICE_DATES  = "FETCH_SERVICE_DATES ";

export const service = async (accountNumberList) => {  
  const options: object = {
      url: `/Api/SearchCriteria/FetchServiceDatesFromFoundCases`,
    method: "POST",    
    body: JSON.stringify(accountNumberList),
    headers: {
      'Content-Type': 'application/json'
    }
  };
  const response = callMvcApi(options);
  return response;
};
const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(FETCH_SERVICE_DATES , service, mock);
